<template>
  <div>
    <v-icon color="blue darken-1" @click="visible = !visible"
      >mdi-information-outline
    </v-icon>
    <span v-if="visible">{{ $t(text) }}</span>
  </div>
</template>
<script>
export default {
  name: "FormHelper",
  data() {
    return {
      visible: false,
    }
  },
  props: {
    text: String,
  },
}
</script>
